import React from 'react';
import { Box, Typography, Button, Container, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <Box id="home" sx={{ position: 'relative', bgcolor: '#0a2540', overflow: 'hidden', pt: 15, pb: 12 }}>
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(135deg, #0a2540 0%, #102a43 100%)', zIndex: 0 }} />
      <Box sx={{ position: 'absolute', top: -100, right: -100, width: 600, height: 600, background: 'radial-gradient(circle, rgba(46,125,50,0.2) 0%, rgba(0,0,0,0) 70%)', zIndex: 1 }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={7}>
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <Typography variant="overline" sx={{ color: '#66bb6a', fontWeight: 'bold', letterSpacing: 3 }}>
                ESTABLISHED 2014
              </Typography>
              <Typography variant="h1" sx={{ color: 'white', mb: 3, fontSize: { xs: '2.2rem', md: '3.5rem' } }}>
                Sustainable Environmental Water & 
                <br />
                <span style={{ color: '#66bb6a' }}>Agri-Tech Solutions</span>
              </Typography>
              <Typography variant="h5" sx={{ color: '#cfd8dc', mb: 5, fontWeight: 300, maxWidth: 650, lineHeight: 1.6 }}>
Expert Consultancy Services for Source Water Assessments, Wastewater Treatment (STP and ETP), Industry Environmental Compliance, Hydrogeological Investigations and Smart Agriculture              </Typography>
              
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Link to="contact" smooth={true} offset={-70}>
                  <Button variant="contained" color="secondary" size="large" sx={{ px: 4, py: 1.5 }}>
                    Consult Our Experts
                  </Button>
                </Link>
                <Link to="projects" smooth={true} offset={-70}>
                  <Button variant="outlined" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.3)', px: 4, py: 1.5 }}>
                    View Portfolio
                  </Button>
                </Link>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'block' } }}>
            <motion.div initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.4, duration: 0.8 }}>
              <Paper sx={{ 
                p: 4, 
                bgcolor: 'rgba(255,255,255,0.05)', 
                backdropFilter: 'blur(10px)', 
                border: '1px solid rgba(255,255,255,0.1)',
                color: 'white', borderRadius: 4 
              }}>
                <Typography variant="h6" gutterBottom sx={{ color: '#66bb6a' }}>Why G&B Solutions?</Typography>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={6}>
                    <Typography variant="h3" sx={{ color: 'white', fontWeight: 'bold' }}>30+</Typography>
                    <Typography variant="caption" sx={{ opacity: 0.7 }}>Major Projects</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h3" sx={{ color: 'white', fontWeight: 'bold' }}>10+</Typography>
                    <Typography variant="caption" sx={{ opacity: 0.7 }}>Years Experience</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ mt: 2, opacity: 0.8, fontStyle: 'italic' }}>
                      "Enhancing quality of environment and water resources."
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;